// extracted by mini-css-extract-plugin
export default {"button":"HeaderSettingsButton_button__7fuDP","button_active":"HeaderSettingsButton_button_active__mTtZC","icon":"HeaderSettingsButton_icon__MFpUg"};